import { NgModule } from '@angular/core';
import { SdSeoTextModule } from './components';

@NgModule({
  imports: [SdSeoTextModule],
})
export class SeoUiModule {}
